import React from 'react';
import './footer.css';

interface FooterProps {
  showFooter?: boolean;
}

export const FooterWeb = ({ showFooter = true }: FooterProps) => {
  if (!showFooter) return null;

  const getFooterConfig = () => ({
    businessLogo: import.meta.env.VITE_BUSINESS_LOGO || '🏢',
    businessName: import.meta.env.VITE_BUSINESS_NAME || 'TaskMaster',
    businessRegNo: import.meta.env.VITE_BUSINESS_REG_NO || 'REG-001',
    businessAddress: import.meta.env.VITE_BUSINESS_ADDRESS || '123 Business St, City',
    businessPhone: import.meta.env.VITE_BUSINESS_PHONE || '+1 (555) 000-0000',
    businessEmail: import.meta.env.VITE_BUSINESS_EMAIL || 'contact@taskmaster.com',
    copyrightYear: import.meta.env.VITE_COPYRIGHT_YEAR || new Date().getFullYear().toString(),
    copyrightText: import.meta.env.VITE_COPYRIGHT_TEXT || 'All rights reserved.',
    navigationLinks: (import.meta.env.VITE_FOOTER_NAV_LINKS || 'Home,About,Blog,Contact').split(','),
  });

  const config = getFooterConfig();

  const handleNavClick = (link: string) => {
    const routes: Record<string, string> = {
      'Home': '/',
      'About': '/profile',
      'Blog': '/blog',
      'Contact': '/',
    };
    const route = routes[link] || '/';
    window.location.href = route;
  };

  return (
    <footer className="footer-container">
      {/* Upper Section - Navigation, Business Info, Logo */}
      <div className="footer-upper">
        <div className="footer-section footer-logo-section">
          <div className="footer-logo">{config.businessLogo}</div>
          <h3 className="footer-business-name">{config.businessName}</h3>
        </div>

        <div className="footer-section footer-nav-section">
          <h4 className="footer-section-title">Navigation</h4>
          <ul className="footer-nav-list">
            {config.navigationLinks.map((link) => (
              <li key={link}>
                <button 
                  className="footer-nav-link" 
                  onClick={() => handleNavClick(link.trim())}
                >
                  {link.trim()}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-section footer-info-section">
          <h4 className="footer-section-title">Business Info</h4>
          <div className="footer-info-content">
            <p>
              <strong>Registration:</strong> <br />
              {config.businessRegNo}
            </p>
            <p>
              <strong>Address:</strong> <br />
              {config.businessAddress}
            </p>
            <p>
              <strong>Phone:</strong> <br />
              <a href={`tel:${config.businessPhone}`} className="footer-link">
                {config.businessPhone}
              </a>
            </p>
            <p>
              <strong>Email:</strong> <br />
              <a href={`mailto:${config.businessEmail}`} className="footer-link">
                {config.businessEmail}
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Section - Copyright and Terms */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          <p>
            &copy; {config.copyrightYear} {config.businessName}. {config.copyrightText}
          </p>
        </div>
        <div className="footer-terms">
          <a href="/terms" className="footer-link">Terms & Conditions</a>
          <span className="footer-separator">|</span>
          <a href="/privacy" className="footer-link">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};
